const getRandomString = (num = 4) => {
  return Array(num)
    .fill(0)
    .map(() => String.fromCharCode(Math.round(Math.random() * 25) + 97))
    .join("");
};

export default getRandomString;
